import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { FooterContentComponent, HeaderContentComponent } from '../content-components';

@Component({
  selector: 'wl-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.less'],
  standalone: false
})
export class CardComponent implements OnInit {
  @Input() style: object;

  @ContentChild(HeaderContentComponent) headerContent: HeaderContentComponent;
  @ContentChild(FooterContentComponent) footerContent: FooterContentComponent;

  headerTemplate: TemplateRef<any>;
  constructor() {}

  ngOnInit(): void {}
}
